// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@keyframes pulse-data-v-6b2868f2{50%{opacity:.5}}[data-v-6b2868f2] .graphic-container h1{margin-bottom:24px}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
